import { OpenInNewIcon } from '@systemeio/ui/icons'
import { FormSelect } from '@systemeio/ui'
import EditTriggerWrapper from 'modules/automation-rules/triggers/components/edit-triggers/components/edit-trigger-wrapper'
import { EditTriggerItemInterface } from 'modules/automation-rules/triggers/components/edit-triggers/types/edit-trigger-item-interface'
import { AutomationRuleTriggersDataEnum } from 'modules/automation-rules/triggers/enums/trigger-enum'
import { TriggerBookingCreatedEditInterface } from 'modules/automation-rules/triggers/types/automation-rule-triggers-edit-interface'
import { getDataFromObj } from 'modules/automation-rules/utils/get-filter-data'
import React from 'react'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

interface TriggerBookingCreatedItemProps
  extends EditTriggerItemInterface<TriggerBookingCreatedEditInterface> {}

const TriggerBookingCreatedItem = ({
  triggers,
  trigger,
  idx,
  onDelete,
  setRules,
  errors,
  isStatic,
}: TriggerBookingCreatedItemProps) => {
  const { t } = useLocoTranslation()

  return (
    <EditTriggerWrapper trigger={trigger} onDelete={() => onDelete(idx)}>
      {({ renderTriggerLabel, data, onOpen, onClear }) => (
        <>
          <FormSelect
            disabled={isStatic}
            onOpen={() => onOpen(AutomationRuleTriggersDataEnum.booking_created)}
            label={renderTriggerLabel({
              label: t('dashboard.automation_rule.event_title'),
              additionalLabel: trigger.bookingEvent.id ? (
                <LinkWithoutPrefetch
                  href={`/calendar/${trigger.bookingEvent.id}`}
                  className={`group self-center outline-hidden`}
                  target={'_blank'}
                >
                  <OpenInNewIcon
                    className={
                      'main-transition-colors group-focus-visible:fill-brand-primary hover:fill-brand-primary'
                    }
                  />
                </LinkWithoutPrefetch>
              ) : undefined,
            })}
            placeholder={t('dashboard.automation_rule.choose_event')}
            value={trigger.bookingEvent.id}
            staticData={getDataFromObj(trigger.bookingEvent)}
            data={data.eventsData}
            onChange={data => {
              setRules(prev => {
                return {
                  ...prev,
                  triggers: triggers.map((el, i) => {
                    if (idx === i) {
                      return {
                        ...el,
                        bookingEvent: { id: data },
                      }
                    } else {
                      return el
                    }
                  }),
                }
              })
            }}
            error={errors.automationTriggers[trigger.id]?.bookingEvent?.join('')}
          />
        </>
      )}
    </EditTriggerWrapper>
  )
}

export default TriggerBookingCreatedItem
